import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=777eab4a&"
import script from "./Customer.vue?vue&type=script&lang=js&"
export * from "./Customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports